import { Box, StyledComponentProps, SxProps, Theme } from '@mui/material';
import DOMPurify, { Config } from 'dompurify';
import * as React from 'react';

import { ClassKey } from './useStyles';

export interface Props extends StyledComponentProps<ClassKey> {
  html: string;
  config?: Config;
  className?: string | undefined;
  sx?: SxProps<Theme>;
}

export const SanitizeHTML: React.FC<Props> = (props) => {
  const { className, html, config, sx } = props;

  const defaultOptions = {
    USE_PROFILES: { html: true },
  };

  return (
    <Box
      dangerouslySetInnerHTML={{
        __html: config
          ? (DOMPurify.sanitize(html, config) as string)
          : (DOMPurify.sanitize(html, defaultOptions) as string),
      }}
      sx={sx}
      //TODO: remove className furhter when all will be implemented
      className={className}
    />
  );
};
